import { useMutation, useQueryClient } from '@tanstack/react-query';
import { memberRequestsAvailabilityService } from 'shared/src/api/memberRequestsAvailabilityService';
import { queryKey } from '../../../../../constant/queryKey';
import type { GetMemberRequestsAvailabilityResponse } from 'shared/src/api/memberRequestsAvailabilityService/getMemberRequestsAvailability';

export const usePostMemberRequests = (marketId: number) => {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => memberRequestsAvailabilityService.post(marketId),
    onSuccess: () => {
      client.setQueryData<GetMemberRequestsAvailabilityResponse>(
        queryKey.memberRequestsAvailability(marketId),
        oldData => {
          if (!oldData) return oldData;

          return {
            ...oldData,
            availability: {
              ...oldData.availability,
              is_requested: true,
            },
          };
        },
      );
    },
  });
};
